/*
  Responsive Screens (min-width)
  --screen-xs: 480px;   /* very small devices, portrait phones
  --screen-sm: 640px;   /* small devices
  --screen-md: 768px;   /* tablets
  --screen-lg: 1024px;  /* laptops
  --screen-xl: 1280px;  /* full desktop layout
 */
export const breakpoints = {
  xs: 480,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
} as const;

export type BreakpointKey = keyof typeof breakpoints;

type MediaQuery<K extends BreakpointKey> = `@media (min-width: ${(typeof breakpoints)[K]}px)`;

type MQMap = { [K in BreakpointKey]: MediaQuery<K> };

export const breakpoint = Object.fromEntries(
  (Object.keys(breakpoints) as BreakpointKey[]).map(key => {
    return [key, `@media (min-width: ${breakpoints[key]}px)`];
  }),
) as MQMap;
